import {
  IAccountStatusType,
  IApiOptinsAttributes,
  IKvkType,
} from '../api/models/account/account.types';

export enum EGender {
  FEMALE = 'F',
  MALE = 'M',
}

export const MAX_CHARACTERS_ANNOUNCE = 2000;
export const MIN_CHARACTERS_ANNOUNCE = 2;

export interface IAccountAttributes {
  email: string;
  nickname: string;
  hasCompletedProfile: boolean;
  status: IAccountStatusType;
  kvk: IKvkType;
  gender: EGender;
  wantedGender: EGender;
  isCrossSell: boolean;
  geo?: {
    city: {
      name: string;
    };
  };
  age?: number;
  privacy?: { privatePicture: boolean };
  birthdate?: string;
}

export interface IAccount {
  id: string;
  hashedId?: string;
  attributes: IAccountAttributes;
  pictures: string[];
  optins: IOptins | undefined;
}

export interface IAccountEntries {
  [id: string]: IAccount;
}

export type IOptins = IApiOptinsAttributes;
